import React, { useEffect } from "react";
import Header from "./Header";
import { calldailyposy } from "../Api/api";
export default function Daily_blog() {

  async function caller()
  {
    var data=await calldailyposy();
    console.log(data);
  }
  useEffect(()=>{
    caller()
  },[]);
  return (
    <div>
      <Header />
    </div>
  );
}
